import { Button, Grid, Hidden, IconButton, Stack, Typography } from "@mui/material";
import FerreroLogo from "./FerreroLogo";
import LanguageSelect from "../layout/LanguageChoiceMenu";
import MenuIcon from "@mui/icons-material/Menu";
import { SignOutButton } from "../login/SignOutButton";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from 'react-router-dom';

interface Props {
  toggleSidebar: () => void;
}

export default function Header({ toggleSidebar }: Props) {

  const {t} = useTranslation()

  return (
    <Grid container>
      <Grid
        item
        md={4}
        xs={11}
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
      >
         <Hidden mdUp>
          <IconButton
            color="inherit"
            edge="start"
            onClick={toggleSidebar}
            sx={{ mr: 1 }}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Hidden mdDown>
        <Stack direction="row" spacing={2}>
          <Button to="/" variant="text" sx={{color: "white"}} component={RouterLink}>{t("Home")}</Button>
          <Button to="/applications" variant="text" sx={{color: "white"}} component={RouterLink}>{t("Applications")}</Button>
          <Button to="/profile" variant="text" sx={{color: "white"}} component={RouterLink}>{t("Profile")}</Button>
        </Stack>
        </Hidden>
        <Hidden mdUp>
        <NavLink to="/" color="inherit" style={{textDecoration:'none'}}>
          <Typography component={"span"} variant="h6" sx={{color: "white"}}>
            MAD
          </Typography>
        </NavLink>
        </Hidden>
      </Grid>
       <Hidden mdDown>
        <Grid item md={4} sx={{ height: "39px" }}>
         <FerreroLogo color="white" /> 
        </Grid>
        </Hidden> 
        <Grid
          item
          md={4}
          xs={1}
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
        >
          <LanguageSelect /> 
          <SignOutButton />
        </Grid> 
    </Grid>
  );
}
